/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import styled from 'styled-components';
import { AvatarWrapper, Content, CONTENT_TYPES, IconInfo, withTooltip, THEMES } from 'cdk-radial';
import { Constants } from '../../../../constants/constants';

const PrivacyProtectionIcon = styled(IconInfo)`
  fill: rgba(21, 27, 37, 0.7);
`;
const PrivacyProtectionInfo = withTooltip(PrivacyProtectionIcon, {
  id: 'app-privacy-protection-info-tooltip',
  text: 'This App has an API that contains Consumer Privacy Protection functionality that will be surfaced during the subscription process where the dealer can opt in or out.',
  theme: THEMES.LIGHT
});

export const AppLink = ({ data: { solutionData }, goToMarketplace }) => {
  const { orgId, overview, id } = solutionData;

  const getLogo = (solutionInfo) => {
    let solutionLogo = '';
    if (solutionInfo.isAppNotListed) {
      let initials = solutionInfo.orgName.split(' ');
      initials.forEach((split) => {
        solutionLogo = solutionLogo + split.charAt(0).toUpperCase();
      });
      solutionLogo = solutionLogo.substring(0, 2);

      return (
        <AvatarWrapper className="org-logo">
          <Content
            style={{
              color: 'white',
            }}
          >
            {solutionLogo}
          </Content>
        </AvatarWrapper>
      );
    }

    return (
      <img
        src={solutionInfo?.overview?.solutionLogo}
        alt={'app Logo'}
        className="active_xs-logo"
      ></img>
    );
  };

  return (
    <div className="active_inline-block">
      <span className="active_xs-logo-container">{getLogo(solutionData)}</span>
      <div className="active_app-name">
        <a
          className="active_app-link"
          href="#"
          onClick={() => goToMarketplace(orgId, overview?.name, id)}
        >
          {solutionData?.overview?.name || solutionData.displayName}
        </a>
        {solutionData?.isAppNotListed && (
          <Content type={CONTENT_TYPES.CAPTION}>
            {Constants.NOT_IN_MARKETPLACE}
          </Content>
        )}
      </div>
      { solutionData?.privacyProtection && (
        <span className="active_app-privacy-protection">
          <PrivacyProtectionInfo />
        </span>
      )}
    </div>
  );
};
